/**
 * Можно ли открыть новость о рейтинговых обличиях прямо сейчас. Новость —
 * самая низкоприоритетная модалка главного меню: она ждет, пока свободна
 * очередь всех остальных его модалок (isOtherMenuModalQueueBusy — в том числе
 * пока наградные сверяются с сервером), и не ложится поверх того, что открыто
 * самим игроком или App: модалки входа для гостя, предложения установить
 * приложение, вступительной колоды.
 *
 * @param {Object} params
 * @param {boolean} params.isQueued - новость положена и не заглушена на этот заход
 * @param {boolean} params.isOpen - уже открыта
 * @param {boolean} params.isOtherMenuModalQueueBusy
 * @param {string|null} [params.loginRequiredReason]
 * @param {boolean} [params.isAppInstallPromoOpen]
 * @param {boolean} [params.isIntroSlidesVisible]
 * @returns {boolean}
 */
export const checkIfRankSkinsNewsOpenable = ({
  isQueued,
  isOpen,
  isOtherMenuModalQueueBusy,
  loginRequiredReason,
  isAppInstallPromoOpen,
  isIntroSlidesVisible,
}) => Boolean(isQueued)
  && !isOpen
  && !isOtherMenuModalQueueBusy
  && !loginRequiredReason
  && !isAppInstallPromoOpen
  && !isIntroSlidesVisible;
